if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector("span") : null;
        this.submitButtons = Array.from(this.querySelectorAll('button[type="submit"][name="add"]'));
        this.upsellVariantId = this.dataset.upsellVariantId;
        this.stayOnPage = this.dataset.stayOnPage === "true";

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const clickedButton = evt.submitter || this.querySelector('[data-bc-product-submit]') || this.submitButton;
        if (!clickedButton || clickedButton.getAttribute("aria-disabled") === "true") return;

        this.submitButton = clickedButton;
        this.submitButtonText =
          clickedButton.querySelector('[data-bc-secondary-label]') ||
          clickedButton.querySelector("span");
        const submitMode = clickedButton.dataset.bcSubmitMode || (this.stayOnPage ? "stay" : "default");
        const submitSpinner = clickedButton.querySelector(".loading__spinner");

        this.handleErrorMessage();

        (this.submitButtons.length ? this.submitButtons : [clickedButton]).forEach((button) =>
          button.setAttribute("aria-disabled", true)
        );
        clickedButton.classList.add("loading");
        if (submitSpinner) submitSpinner.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart && !this.stayOnPage) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        this.skipCart = false;
        const variantInput = this.form.querySelector('[name=id]');
        if (variantInput?.dataset?.skipCart === 'true') {
          this.skipCart = true;
        }

        const legacyUpsellCheck = this.upsellVariantId
          ? fetch(`${routes.cart_url}.js`, { headers: { Accept: "application/json" } })
              .then((response) => response.json())
              .then((cartState) => {
                if (cartState.item_count === 0) {
                  return fetch(
                    `${routes.cart_add_url}`,
                    this.getUpsellProductConfig()
                  );
                }
              })
          : Promise.resolve();

        legacyUpsellCheck
          .then(() => fetch(`${routes.cart_add_url}`, config))
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            if (this.skipCart) {
              window.location = "/checkout";
              return;
            }

            // BundiCare primary CTA: add the selected product and move to the full cart page.
            if (submitMode === "cart") {
              window.location = window.routes?.cart_url || "/cart";
              return;
            }

            // BundiCare secondary CTA: add the item, stay on the PDP,
            // and provide strong visual feedback without opening a drawer.
            if (submitMode === "stay" || this.stayOnPage) {
              const cartStateResponse = await fetch(`${routes.cart_url}.js`, {
                headers: { Accept: "application/json" },
              });
              const cartState = await cartStateResponse.json();

              this.updateCartBubble(cartState.item_count || 0);
              this.showInlineConfirmation(cartState.item_count || 0);
              this.animateCartFeedback();
              if (submitMode === "stay") this.showSecondaryButtonSuccess(clickedButton);

              if (typeof publish !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  cartData: cartState,
                });
              }

              this.error = false;
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage('Valami nem sikerült. Kérlek, próbáld újra.');
          })
          .finally(() => {
            clickedButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) {
              (this.submitButtons.length ? this.submitButtons : [clickedButton]).forEach((button) =>
                button.removeAttribute("aria-disabled")
              );
            }
            if (submitSpinner) submitSpinner.classList.add("hidden");
          });
      }

      updateCartBubble(itemCount) {
        const cartIcon = document.querySelector('#cart-icon-bubble');
        if (!cartIcon) return;

        let bubble = cartIcon.querySelector('.cart-count-bubble');
        if (itemCount <= 0) {
          if (bubble) bubble.remove();
          return;
        }

        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          cartIcon.appendChild(bubble);
        }

        bubble.innerHTML = '';
        if (itemCount < 100) {
          const count = document.createElement('span');
          count.setAttribute('aria-hidden', 'true');
          count.textContent = itemCount;
          bubble.appendChild(count);
        }

        const hidden = document.createElement('span');
        hidden.className = 'visually-hidden';
        hidden.textContent = `${itemCount} termék a kosárban`;
        bubble.appendChild(hidden);
      }

      showInlineConfirmation(itemCount) {
        const confirmation = this.querySelector('[data-bc-product-added]');
        if (!confirmation) return;

        confirmation.hidden = false;
      }

      animateCartFeedback() {
        const cartIcon = document.querySelector('#cart-icon-bubble');
        if (!cartIcon) return;

        cartIcon.classList.remove('bc-cart-pop');
        void cartIcon.offsetWidth;
        cartIcon.classList.add('bc-cart-pop');

        const oldBadge = cartIcon.querySelector('.bc-cart-plus-one');
        if (oldBadge) oldBadge.remove();

        const badge = document.createElement('span');
        badge.className = 'bc-cart-plus-one';
        badge.setAttribute('aria-hidden', 'true');
        badge.textContent = '+1';
        cartIcon.appendChild(badge);

        window.setTimeout(() => {
          cartIcon.classList.remove('bc-cart-pop');
          badge.remove();
        }, 950);
      }

      showSecondaryButtonSuccess(button) {
        const label = button?.querySelector('[data-bc-secondary-label]');
        if (!label) return;
        const original = label.textContent;
        label.textContent = 'Kosárba került ✓';
        button.classList.add('is-added');
        window.setTimeout(() => {
          label.textContent = original.trim() || 'Kosárba teszem';
          button.classList.remove('is-added');
        }, 1200);
      }

      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append("id", this.upsellVariantId);
        upsellFormData.append("quantity", 1);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = upsellFormData;

        return config;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
